import List from "./List";
import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

export const NewsList = List;
export const NewsCreate = Create;
export const NewsShow = Show;
export const NewsEdit = Edit;
